import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { colorNameMap } from "../../colorNameMap";
import { eramFontDimensionMap, getBitmapTextStyles } from "../../eramFont";
export const Label = ({ x = 0, y = 0, text, fontName = "eramText2", tint = colorNameMap.lightGrey, }) => {
    const { width: fontWidth, height: fontHeight } = eramFontDimensionMap[fontName];
    const lineY = text.split("\n").length * fontHeight;
    const lineWidth = Math.max(...text.split("\n").map((line) => line.length)) * fontWidth;
    return (_jsxs("container", { x: x, y: y, eventMode: "none", children: [_jsx("graphics", { y: lineY, zIndex: 0, draw: (graphics) => {
                    graphics.clear();
                    graphics.moveTo(0, 0).lineTo(lineWidth, 0).stroke({ width: 1, color: tint });
                } }), _jsx("bitmapText", { zIndex: 1, y: 0, text: text, style: { ...getBitmapTextStyles(fontName), fill: tint } })] }));
};
//# sourceMappingURL=Label.js.map